import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const SanityEventCard = z.object({
  _id: z.string(),
  title: z.string(),
  href: z.string(),
  excerpt: z.string(),
  ctaLabel: z.string(),
  startDate: z.string(),
  endDate: z.string().nullable(),
  isPast: z.boolean(),
  thumbnailImage: SanityImage,
  category: z.object({
    title: z.string(),
    pluralTitle: z.string(),
    slug: z.string(),
    badgeTone: z.enum(['electric', 'cipher']),
  }),
});
export type SanityEventCard = z.infer<typeof SanityEventCard>;

export const eventCardProjection = groq`{
  _id,
  title,
  'href': '/events/' + slug.current,
  excerpt,
  'ctaLabel': select(
    coalesce(endDate, startDate) < now() && defined(ctaLabelPast) && ctaLabelPast != '' => ctaLabelPast,
    coalesce(ctaLabel, 'Learn More')
  ),
  startDate,
  'endDate': coalesce(endDate, null),
  'isPast': coalesce(endDate, startDate) < now(),
  thumbnailImage ${image},
  category-> {
    title,
    pluralTitle,
    'slug': slug.current,
    'badgeTone': coalesce(badgeTone, 'cipher'),
  },
}`;
